// Построение ссылки tg://proxy для админки.
//
// standard → префикс `dd` (классический FakeTLS-Random)
// premium  → префикс `ee` (FakeTLS с встроенным cloak-доменом)
//
// На бэкенде эта же логика живёт в services/proxy.py:build_proxy_link*,
// фронт должен быть с ней синхронен — иначе test_link / admin-test-link
// будет не совпадать с тем что юзер видит в боте.

import type { Tier } from "./types";

// Default cloak когда вызывающий не передал явный domain. Должен
// совпадать с дефолтом backend (services/settings_store.py:
// get_premium_cloak_domain → "cloudflare.com"). Если в БД глобальный
// premium_cloak_domain другой — фронт всё равно отрисует ссылку
// корректно только если ВЫЗЫВАЮЩИЙ передаст cloakDomain явно
// (например, s.cloak_domain || globalCloakFromSettings).
const DEFAULT_CLOAK_DOMAIN = "cloudflare.com";

function toHex(s: string): string {
  let out = "";
  for (let i = 0; i < s.length; i++) {
    out += s.charCodeAt(i).toString(16).padStart(2, "0");
  }
  return out;
}

export interface ProxyTarget {
  host: string;
  port: number;
  secret: string;
  tier?: Tier | null;
  cloakDomain?: string;
}

export function buildProxyLink(t: ProxyTarget): string {
  if (!t.host || !t.secret) return "";
  const tier = (t.tier ?? "standard") as Tier;
  if (tier === "premium") {
    const cloak = t.cloakDomain ?? DEFAULT_CLOAK_DOMAIN;
    const domainHex = toHex(cloak);
    return `tg://proxy?server=${t.host}&port=${t.port}&secret=ee${t.secret}${domainHex}`;
  }
  return `tg://proxy?server=${t.host}&port=${t.port}&secret=dd${t.secret}`;
}
